"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArtifactDisabledItems = void 0;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var ArtifactDisabledItems = /*#__PURE__*/function () {
  function ArtifactDisabledItems() {
    _classCallCheck(this, ArtifactDisabledItems);
    _defineProperty(this, "disabledByOrg", null);
    _defineProperty(this, "disableAddArtifactMapping", null);
    _defineProperty(this, "disableDeleteArtifactsMapping", null);
    _defineProperty(this, "disableSaveArtifactTag", null);
    _defineProperty(this, "partialDisabledToolTip", null);
  }
  _createClass(ArtifactDisabledItems, [{
    key: "isACustomToolTipNeeded",
    value: function isACustomToolTipNeeded() {
      // If all actions regarding menu buttons are enabled or disabled then a custom tool tip not needed
      var allEnabled = this.disableDeleteArtifactsMapping && this.disableSaveArtifactTag;
      if (allEnabled) {
        return !allEnabled;
      }
      var noneEnabled = !this.disableDeleteArtifactsMapping && !this.disableSaveArtifactTag;
      if (noneEnabled) {
        return !noneEnabled;
      }
      return true;
    }
  }, {
    key: "isTagToolTipDisabled",
    value: function isTagToolTipDisabled() {
      if (this.disabledByOrg) {
        return true;
      }

      // Evaluate only the actions that belong to the menu buttons
      var allTagToolTipDisable = this.disableDeleteArtifactsMapping && this.disableSaveArtifactTag;
      return allTagToolTipDisable ? allTagToolTipDisable : false;
    }
  }, {
    key: "isDisabledByOrg",
    value: function isDisabledByOrg(isBlockedArtifact) {
      if (isBlockedArtifact === undefined) {
        return this.disabledByOrg ? this.disabledByOrg : false;
      }
      var allActionsDisabled = this.disableAddArtifactMapping && this.disableDeleteArtifactsMapping && this.disableSaveArtifactTag;
      if (allActionsDisabled) {
        this.disabledByOrg = allActionsDisabled;
        return allActionsDisabled;
      }
      var noActionsDisabled = !this.disableAddArtifactMapping && !this.disableDeleteArtifactsMapping && !this.disableSaveArtifactTag;
      if (isBlockedArtifact && noActionsDisabled) {
        this.disabledByOrg = true;
        return true;
      }
      this.disabledByOrg = false;
      return false;
    }
  }]);
  return ArtifactDisabledItems;
}();
exports.ArtifactDisabledItems = ArtifactDisabledItems;